<vs-dialog
  #dialog
  [config]="{ disableBackdropDismiss: submitting, dialogContainerClass: 'w-[584px] max-w-[95vw] max-h-[90vh]' }"
  (closed)="reset()"
>
  <vs-dialog-header
    [config]="{ mode: 'simple', title: 'Upload document', icon: 'file-plus-02', iconTheme: 'primary', showDivider: true, hideCloseButton: submitting }"
  ></vs-dialog-header>
  <form [formGroup]="form" (ngSubmit)="submit()" class="p-5 flex flex-col gap-4">
    <fieldset [disabled]="submitting" class="flex flex-col gap-4">
      <vs-form-field [config]="{ label: 'Document name (required)' }">
        <input vsInput type="text" formControlName="title" aria-label="Document name" />
        <p
          *ngIf="form.controls.title.touched && form.controls.title.hasError('required')"
          class="text-sm text-error-800"
          role="alert"
        >
          Enter a document name.
        </p>
        <p
          *ngIf="form.controls.title.touched && form.controls.title.hasError('maxlength')"
          class="text-sm text-error-800"
          role="alert"
        >
          Document names must be 255 characters or fewer.
        </p>
      </vs-form-field>
      <vs-form-field [config]="{ label: 'Category (required)' }">
        <vs-select
          vsInput
          formControlName="category"
          [config]="{ placeholder: 'Choose a category' }"
          aria-label="Category"
        >
          <li *ngFor="let category of categories" vs-select-option [value]="category">
            {{ categoryLabels[category] }}
          </li>
        </vs-select>
        <p
          *ngIf="form.controls.category.touched && form.controls.category.invalid"
          class="text-sm text-error-800"
          role="alert"
        >
          Choose a category.
        </p>
      </vs-form-field>
      <vs-form-field [config]="{ label: 'Service/inspection date (optional)' }">
        <input
          vsInput
          type="date"
          [showDefaultPicker]="true"
          formControlName="serviceDate"
          aria-label="Service/inspection date"
        />
        <p
          *ngIf="form.controls.serviceDate.touched && form.controls.serviceDate.invalid"
          class="text-sm text-error-800"
          role="alert"
        >
          Choose a valid calendar date.
        </p>
      </vs-form-field>
      <vs-form-field [config]="{ label: 'Covered asset (optional)' }">
        <vs-select vsInput formControlName="assetId" [config]="{ placeholder: 'None' }" aria-label="Covered asset">
          <li vs-select-option [value]="''">None</li>
          <li *ngIf="warranty?.asset && warranty?.assetId" vs-select-option [value]="warranty?.assetId">
            {{ warranty?.asset?.name }}
          </li>
        </vs-select>
        <p *ngIf="form.controls.assetId.invalid" class="text-sm text-error-800" role="alert">
          Choose this warranty's covered asset or None.
        </p>
      </vs-form-field>
      <label class="flex flex-col gap-2 text-sm font-medium">
        File (required)
        <input
          #fileInput
          type="file"
          accept=".pdf,.jpg,.jpeg,.png,.webp"
          (change)="selectFile($event)"
          aria-label="Document file"
          class="block w-full text-sm"
        />
        <span class="text-gray-500 font-normal">PDF, JPEG, PNG or WebP. Maximum 10 MiB.</span>
      </label>
      <ng-container *ngIf="form.controls.file.touched">
        <p *ngIf="form.controls.file.hasError('required')" class="text-sm text-error-800" role="alert">
          Choose a file to upload.
        </p>
        <p *ngIf="form.controls.file.hasError('emptyFile')" class="text-sm text-error-800" role="alert">
          The file is empty. Choose a non-empty file.
        </p>
        <p *ngIf="form.controls.file.hasError('fileTooLarge')" class="text-sm text-error-800" role="alert">
          Choose a file that is 10 MiB or smaller.
        </p>
        <p *ngIf="form.controls.file.hasError('fileType')" class="text-sm text-error-800" role="alert">
          Choose a PDF, JPEG, PNG or WebP file with a matching filename extension.
        </p>
      </ng-container>
    </fieldset>
    <div *ngIf="errors.length" role="alert" class="text-sm text-error-800">
      <p *ngFor="let error of errors">{{ error }}</p>
    </div>
    <div class="flex justify-end gap-3">
      <button vs-button appearance="outline" type="button" [disabled]="submitting" (click)="dialog.close()">
        Cancel
      </button>
      <button vs-button type="submit" [disabled]="submitting">
        {{ submitting ? 'Uploading…' : 'Upload document' }}
      </button>
    </div>
  </form>
</vs-dialog>
